// AHA-47744: legacy content slide -> content-v2 slide conversion.
// Leaf module on purpose: the notice component, the Vuex module and the flag
// getter all import it, and none of them should drag the store in transitively.

export const CONVERT_CONTENT_V1_TO_V2_FLAG = 'AHA-47744-convert-content-v1-to-v2'

// The ahaaiv2 converter also accepts textSlide / bulletPoints; the button
// ships on freestyle first.
export const CONVERTIBLE_SLIDE_TYPES = ['freestyle']
